import { render } from "./modernInput.vue?vue&type=template&id=6ef81a04&scoped=true&ts=true"
import script from "./modernInput.vue?vue&type=script&lang=ts"
export * from "./modernInput.vue?vue&type=script&lang=ts"

import "./modernInput.vue?vue&type=style&index=0&id=6ef81a04&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef81a04"]])

export default __exports__